import { render, staticRenderFns } from "./EditBinNumber.vue?vue&type=template&id=523fdc9b"
import script from "./EditBinNumber.vue?vue&type=script&lang=js"
export * from "./EditBinNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports